import { ReactNode } from 'react';
import { CircleAlert } from 'lucide-react';
import { Badge } from '@tinct/web-components';
import { PageOutdatedStatus } from '@tinct/core-api-models';
import { PAGE_OUTDATED_STATUS_CONFIG } from './page-outdated-status-config';

type PageOutdatedStatusBadgeProps = {
  status: PageOutdatedStatus | null | undefined;
  /** Optional label override (e.g. "3 outdated" for summary counts). */
  label?: ReactNode;
  className?: string;
};

/**
 * Renders an "outdated" indicator next to a page's status. Returns null when
 * the page is in sync (`none` / null), so callers can drop it in unconditionally.
 */
export function PageOutdatedStatusBadge({
  status,
  label,
  className,
}: PageOutdatedStatusBadgeProps) {
  if (!status || status === 'none') return null;
  const config = PAGE_OUTDATED_STATUS_CONFIG[status];
  return (
    <Badge
      variant="secondary"
      className={`gap-1.5 rounded-sm text-red-500 ${className ?? ''}`.trim()}
    >
      <CircleAlert />
      {label ?? config.label}
    </Badge>
  );
}
